"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAROUSEL_MAX_BODY_LENGTH = exports.CAROUSEL_MAX_HEADLINE_LENGTH = exports.CAROUSEL_MAX_TOPIC_LENGTH = exports.CAROUSEL_MAX_SLIDES = exports.CAROUSEL_MIN_SLIDES = void 0;
exports.CAROUSEL_MIN_SLIDES = 1;
exports.CAROUSEL_MAX_SLIDES = 5;
exports.CAROUSEL_MAX_TOPIC_LENGTH = 500;
exports.CAROUSEL_MAX_HEADLINE_LENGTH = 80;
exports.CAROUSEL_MAX_BODY_LENGTH = 200;
